import _ from 'lodash';
import { createSelector } from 'reselect';
import { RootState } from '../reducers';

const getProducts = (state: RootState) => state.products.products;

export const getSortedProducts = createSelector([getProducts], (products) => {
  return _.sortBy(products || [], p => p.displayNameAndSize);
});
